import { render, staticRenderFns } from "./ClientDelete.vue?vue&type=template&id=e3e4afda&scoped=true&"
import script from "./ClientDelete.vue?vue&type=script&lang=js&"
export * from "./ClientDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e4afda",
  null
  
)

export default component.exports